(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digio-shipping-choice"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('digio-shipping-choice')) {
    customElements.define('digio-shipping-choice', class extends HTMLElement {
      connectedCallback() {
        this.start = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.initialize();
      }

      initialize() {
        if (this.initialized) return;
        this.initialized = true;
        this.inputs = [...this.querySelectorAll('input[name="digio_shipping_method"]')];
        this.panel = this.querySelector('[data-locker-panel]');
        this.status = this.querySelector('[data-shipping-status]');
        this.error = this.querySelector('[data-shipping-error]');
        this.method = this.dataset.lockerId ? 'boxnow' : '';
        try { if (!this.method) this.method = sessionStorage.getItem('digio-shipping-method') || ''; } catch {}
        if (!['boxnow', 'elta'].includes(this.method)) this.method = '';
        this.onChoice = (event) => {
          if (!this.inputs.includes(event.target)) return;
          this.method = event.target.value;
          try { sessionStorage.setItem('digio-shipping-method', this.method); } catch {}
          this.error.hidden = true;
          this.render();
          if (this.method === 'elta') this.clearLocker().catch(() => this.showError(this.dataset.errorMessage));
          else if (!this.lockerId()) this.openMap();
        };
        this.onCheckout = (event) => this.checkCheckout(event);
        this.addEventListener('change', this.onChoice);
        document.addEventListener('click', this.onCheckout, true);
        document.addEventListener('submit', this.onCheckout, true);
        this.observer = new MutationObserver(() => this.render());
        this.observer.observe(this.panel, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class'] });
        this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.start);
        document.removeEventListener('click', this.onCheckout, true);
        document.removeEventListener('submit', this.onCheckout, true);
        this.removeEventListener('change', this.onChoice);
        this.observer?.disconnect();
      }

      lockerId() {
        const details = this.panel.querySelector('.tp-box-now-locker-selection__details');
        return details && !details.classList.contains('tp-hidden') ? this.panel.querySelector('#tp-box-now-selected-locker-id')?.textContent.trim() || '' : '';
      }

      render() {
        if (this.method === 'boxnow' && this.lockerId()) this.error.hidden = true;
        this.inputs.forEach((input) => { input.checked = input.value === this.method; input.disabled = Boolean(this.clearing); });
        this.panel.hidden = this.method !== 'boxnow';
        this.status.hidden = !this.error.hidden;
        this.status.textContent = this.clearing ? this.dataset.waitMessage : this.method === 'elta' ? this.dataset.courierMessage : this.method === 'boxnow' ? this.lockerId() ? this.dataset.readyMessage : this.dataset.lockerMessage : this.dataset.chooseMessage;
      }

      openMap() {
        this.panel.hidden = false;
        if (!this.panel.querySelector('iframe')) this.panel.querySelector('.tp-boxnow-map-widget-button')?.click();
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = false;
        this.status.hidden = true;
        this.error.focus({ preventScroll: true });
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      async cartRequest(path, options) {
        const response = await fetch(this.dataset.cartUrl + path, options);
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      }

      async clearLocker() {
        if (this.clearing) return this.clearing;
        this.clearing = this.cartRequest('/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { boxnow_locker_id: '', boxnow_locker_name: '', boxnow_locker_address: '', boxnow_locker_country: '' } })
        }).then((cart) => {
          if (cart.attributes?.boxnow_locker_id) throw new Error('Locker was not cleared');
          this.panel.querySelector('.tp-box-now-locker-selection__details')?.classList.add('tp-hidden');
          this.panel.querySelectorAll('.tp-box-now-locker-map-container iframe').forEach((frame) => frame.remove());
          this.panel.querySelectorAll('#tp-box-now-selected-locker-id, #tp-box-now-selected-locker-name').forEach((node) => { node.textContent = ''; });
        });
        this.render();
        try { await this.clearing; } finally { this.clearing = null; this.render(); }
      }

      async checkCheckout(event) {
        if (this.forwarding) return;
        const button = event.type === 'click' ? event.target.closest?.('#checkout') : event.submitter;
        if (!button || button.id !== 'checkout') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.checking) return;
        this.error.hidden = true;
        if (!this.method) { this.showError(this.dataset.chooseMessage); return; }
        if (this.method === 'boxnow' && !this.lockerId()) { this.showError(this.dataset.lockerMessage); this.openMap(); return; }
        this.checking = true;
        this.setAttribute('aria-busy', 'true');
        try {
          if (this.clearing) await this.clearing;
          let cart = await this.cartRequest('.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
          if (this.method === 'boxnow' && !cart.attributes?.boxnow_locker_id) { this.showError(this.dataset.lockerMessage); this.openMap(); return; }
          if (this.method === 'elta' && cart.attributes?.boxnow_locker_id) await this.clearLocker();
          this.forwarding = true;
          button.form.requestSubmit(button);
          this.forwarding = false;
        } catch { this.forwarding = false; this.showError(this.dataset.errorMessage); }
        finally { this.checking = false; this.removeAttribute('aria-busy'); }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
